var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuperSadFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480.68 480.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e83725;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 167.15,
    cy: 188.75,
    rx: 24.59,
    ry: 24.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 312.39,
    cy: 188.75,
    rx: 24.59,
    ry: 24.58
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.3,328.8c-1.7,0-3.42-.28-5.11-.88-27.16-9.58-53.77-14.51-79.09-14.66-.38,0-.76,0-1.13,0-23.78,0-48.3,4.34-71,12.57-7.98,2.89-16.79-1.23-19.69-9.21-2.89-7.98,1.23-16.79,9.21-19.69,26.44-9.59,55.06-14.56,82.79-14.41,28.75,.17,58.74,5.69,89.13,16.41,8,2.82,12.2,11.6,9.38,19.6-2.23,6.31-8.16,10.26-14.49,10.26Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 240.34,
    cy: 240.23,
    rx: 240.34,
    ry: 240.23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 167.89,
    cy: 177.78,
    rx: 24.53,
    ry: 24.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 312.79,
    cy: 177.78,
    rx: 24.53,
    ry: 24.52
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.97,342.53c-5.41,0-10.65-2.87-13.44-7.94-13.33-24.2-42.43-39.84-74.13-39.84s-58.15,14.09-72.33,36.78c-4.49,7.18-13.95,9.36-21.13,4.87-7.18-4.49-9.36-13.95-4.87-21.13,19.74-31.57,57.42-51.18,98.33-51.18,21.28,0,41.99,5.27,59.89,15.23,17.74,9.87,31.95,23.87,41.1,40.47,4.09,7.42,1.39,16.74-6.03,20.83-2.35,1.29-4.88,1.91-7.39,1.91Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperSadFilled);
export default __webpack_public_path__ + "static/media/super-sad-filled.0e6e8273dddb35a7f15fb39003af0128.svg";
export { ForwardRef as ReactComponent };